import { normalizeGet } from "../common";
import { CONTAINER_NAME } from "../_utils/constant";
var getClipboard = normalizeGet(function (args) {
  return wx.getClipboardData(args);
}, CONTAINER_NAME.WECHAT);
export default getClipboard;